// If we don't want render a component we map that component's name to this function
// in generate-component-factory to 'skip' it by rendering null when that component
// is encountered in the layout response
const SkipRenderingComponent = () => {
  return null;
};

export default SkipRenderingComponent;
